import React from 'react'
import { Cell, List, ListItem, Row, Skeleton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

function ContributionSummaryListItemSkeleton(): JSX.Element {
  const [t] = useTranslation()
  return (
    <ListItem
      aria-hidden
      dense
      startElement={<ListItem.Icon Icon={Skeleton.Icon} />}
      overline={<Skeleton.TypeSkeleton maxWidth={120} randomSeed={2} />}
      primaryText={<Skeleton.TypeSkeleton maxWidth={200} randomSeed={3} />}
      secondaryText={
        <Row gutters="xs" alignY="middle">
          <Cell noShrinkX>{t('tree-person.changed-by.label')}</Cell>
          <Skeleton.Chip />
        </Row>
      }
    />
  )
}

export default function LatestChangesLoading(): JSX.Element {
  return (
    <List data-testid="latest-changes-card-loading">
      <ContributionSummaryListItemSkeleton />
      <ContributionSummaryListItemSkeleton />
      <ContributionSummaryListItemSkeleton />
    </List>
  )
}
